/** Office Customer card → "Technician Notes" — same data the tech Lookup tab edits. */
import { useCallback, useEffect, useState } from "react";
import { listAccessNotes } from "@/lib/api";
import { AccessNotesPanel } from "@/components/tech/AccessNotes";

export function FieldAccessNotesCard({ clientId, clientName, sites = [] }) {
  const [notes, setNotes] = useState([]);
  const load = useCallback(async () => {
    if (!clientId) { setNotes([]); return; }
    try {
      const [c, ...s] = await Promise.all([listAccessNotes("client", clientId), ...sites.map(st => listAccessNotes("site", st.id).catch(() => ({ data: [] })))]);
      const all = [...c.data, ...s.flatMap(r => r.data)];
      all.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
      all.sort((a, b) => (a.pinned ? 0 : 1) - (b.pinned ? 0 : 1));
      setNotes(all);
    } catch { setNotes([]); }
  }, [clientId, sites]);
  useEffect(() => { load(); }, [load]);
  if (!clientId) return null;
  const targets = [{ target: "client", target_id: clientId, label: `Customer: ${clientName}` }, ...sites.map(s => ({ target: "site", target_id: s.id, label: `Site: ${s.name}` }))];
  return (
    <section className="rounded-xl border bg-card p-4" data-testid="client-field-access-notes-card">
      <AccessNotesPanel notes={notes} targets={targets} onChanged={load} title="Technician Notes" />
    </section>
  );
}
